import { Backdrop, CircularProgress, ListItem } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAffirmations, deleteAffirmations, updateAffirmation } from '../../../../api/api';
import { AffirmationWithCategory } from '../../../../interfaces/tell_me/affirmationWithCategory.types';
import { Category } from '../../../../interfaces/tell_me/category.types';
import { AppState } from '../../../../store/store';
import { getDataSetToRedux } from '../../../../utility/getAffirmationAndCategory';

interface Props {
    handleClose: VoidFunction,
    affirmation: AffirmationWithCategory,
    open: boolean,
}

function UpdateAffirmationDialog(props: Props) {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState('');
    const affirmationCategoriesId: Array<string> = props.affirmation.categoryIds;
    const categories = useSelector((state: AppState) => state.categories);
    const [selectedCategories, setSelectedCategories] = useState<Array<Category>>([]);

    // set selectedCategories and text
    useEffect(() => {
        console.log("UPDATE SELECTED CATEGORIES")

        // Set Selected categories for Affirmation
        const _selectedCategories = categories.filter((e) => props.affirmation.categoryIds.includes(e.id)) ?? [];
        setSelectedCategories(_selectedCategories)
        setText(props.affirmation.text);

    }, [props.affirmation, categories, props.open])


    // Update Affirmation, delete unselected, update text, add new categories
    const handleSubmit = async () => {
        if (text !== '' && categories.length > 0) {

            setLoading(true);

            // if selected categories does not contain previous categories delete affirmations from deleted categories
            const toDeleteCategoryIds: Array<string> = [];
            for (let previousCategoryId of affirmationCategoriesId) {
                const selectedCategoryIdList = selectedCategories.map(e => e.id);

                // Unchecked from the category.
                if (!selectedCategoryIdList.includes(previousCategoryId)) {
                    toDeleteCategoryIds.push(previousCategoryId);
                }
            }
            // Delete old categories
            await deleteAffirmations(props.affirmation.id, toDeleteCategoryIds)


            // if selected categories contain a category id which is not from previous categories send add request for the affirmation
            const toAddCategoryIds = [];
            for (let selectedCategory of selectedCategories) {

                // Add To list for create
                if (!affirmationCategoriesId.includes(selectedCategory.id)) {
                    toAddCategoryIds.push(selectedCategory.id);
                }
            }
            await addAffirmations([{
                categoryIds: toAddCategoryIds,
                id: props.affirmation.id,
                text: text, // with (possible) new text
            }]);


            // if a selected category which is from previous categories send update request for the affiramtion.
            const toUpdateCategoryIds: Array<string> = [];
            for (let selectedCategory of selectedCategories) {

                // Previos categories contains selected one.
                if (affirmationCategoriesId.includes(selectedCategory.id)) {
                    toUpdateCategoryIds.push(selectedCategory.id);
                }
            }
            const response = await updateAffirmation({
                text: text,
                id: props.affirmation.id,
                categoryIds: toUpdateCategoryIds,
            })


            // const response = await updateAffirmation(updatedAffirmation);
            await getDataSetToRedux(dispatch);
            setSelectedCategories([]);

            props.handleClose();
            setLoading(false);
            if (response.success) {
                alert("SUCCESS");
            } else {
                alert("ERROR");
                console.log(response);
            }

        }
    }

    // Handle Close Dialog
    const handleClose = () => {
        setSelectedCategories([]);
        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Update Affirmation</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You may update categories and the text of the affirmation.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="text"
                    type="email"
                    fullWidth
                    value={text}
                    onChange={(val) => setText(val.target.value)}
                />
                <Box height={15} />

                {categories.map((category) => {
                    let selected = false;
                    if (selectedCategories.map(e => e.id).includes(category.id)) {
                        selected = true;
                    }

                    return (
                        <ListItem id={category.id}>
                            <Checkbox
                                checked={selected}
                                onChange={() => {
                                    if (!selected) {
                                        const list = [...selectedCategories, category];
                                        setSelectedCategories(list);
                                        return;
                                    }
                                    else {
                                        let indexToRemove = -1;

                                        for (let index = 0; index < selectedCategories.length; index++) {
                                            if (selectedCategories[index].id === category.id) {
                                                indexToRemove = index;
                                            }
                                        }
                                        if (indexToRemove !== -1) {
                                            const list = [...selectedCategories];
                                            list.splice(indexToRemove, 1);
                                            setSelectedCategories(list);
                                        }
                                    }
                                }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                            {category.name}
                        </ListItem>

                    )
                })}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button disabled={loading} onClick={handleSubmit} color="primary">
                    Update affirmation
                </Button>
            </DialogActions>


        </Dialog>
    );
}

export default UpdateAffirmationDialog;